import { IContent } from '@/interfaces/lesson';
import styled, { StyledProp, css } from '@/styled';
import 'eduzz-redactor/redactorx-1-4-2/redactorx.min.css';

const Embed = (props: IContent & StyledProp) => {
  const createElementsToEmbeded = () => {
    const div = document.createElement('div');
    div.innerHTML = props.embed;
    const elements = div.getElementsByTagName('link');
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    return div.innerHTML;
  };

  return (
    <div
      className={props.className + ' rx-content'}
      id='lesson-type-text'
      dangerouslySetInnerHTML={{ __html: createElementsToEmbeded() }}
    />
  );
};

export default styled(Embed)(
  ({ theme }) => css`
    iframe,
    object,
    embed {
      width: auto;
      height: 100%;
      min-width: 100%;
      min-height: 500px;
      display: block;
    }

    p {
      word-break: break-word;
      hyphens: auto;
    }

    code,
    pre {
      background-color: ${theme.palette.alpha(theme.colorBgBase, 0.5)};
    }

    mark {
      background-color: ${theme.colorBgBase};
    }

    p,
    b,
    i,
    cite,
    sup,
    del,
    h2,
    h3,
    h4,
    h5,
    h6,
    h1,
    span,
    code,
    mark,
    kbd,
    blockquote,
    blockquote p,
    p cite,
    pre,
    ul,
    li,
    ol {
      color: ${theme.colorText};
    }

    @media (min-aspect-ratio: 16/9) {
      & > iframe,
      object,
      embed {
        width: 100%;
      }
    }

    @media (max-aspect-ratio: 16/9) {
      & > iframe,
      object,
      embed {
        width: auto;
      }
    }
  `
);
